import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { theme, type GlobalToken, type MappingAlgorithm } from 'antd';
import { extractThemeFromDocumentStyle, type CommutifiToken } from './context';
type AntdUseTokenReturn = ReturnType<typeof theme.useToken>;
type UseTokenReturn = {
  theme: AntdUseTokenReturn['theme'];
  token: GlobalToken & CommutifiToken;
  hashId: string;
  cssVar: AntdUseTokenReturn['cssVar'];
};
function useToken() {
  const $ = _c(8);
  const {
    theme: antdTheme,
    hashId,
    token,
    cssVar
  } = theme.useToken();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = extractThemeFromDocumentStyle();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const commutifiToken = t0;
  let t1;
  if ($[1] !== token) {
    t1 = {
      ...token,
      ...commutifiToken
    };
    $[1] = token;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const mergedToken = t1;
  let t2;
  if ($[3] !== antdTheme || $[4] !== cssVar || $[5] !== hashId || $[6] !== mergedToken) {
    t2 = {
      theme: antdTheme,
      token: mergedToken,
      hashId,
      cssVar
    };
    $[3] = antdTheme;
    $[4] = cssVar;
    $[5] = hashId;
    $[6] = mergedToken;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const value = t2;
  return value;
}
export type { GlobalToken, MappingAlgorithm };
const themeExport: Omit<typeof theme, 'useToken'> & {
  useToken: () => UseTokenReturn;
} = {
  ...theme,
  useToken
};
export default themeExport;